import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Modal,
  Tag,
  message,
} from "antd";

import { connect } from "react-redux";
import {
  req_page_tqa_a00_worktype,
  req_edit_tqa_a00,
  req_delete_tqa_a00,
} from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";

import QuailtyManualLevelAModal from "./quailty-manual-level-a-modal";

class DownloadTemplateModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    department: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "DOWNLOAD",

    domnloadFile: "",
    academicYear: this.props.department.AcademicYear,
    isShowModal: false,
    isEditModal: false,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { WorkTypeCode } = this.props.department;
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      academicYear,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.api_page_run(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      WorkTypeCode,
      token
    );
  };

  api_page_run = async (
    userCode,
    userLevel,
    current,
    pageSize,
    columnSort,
    orderBy,
    searchField,
    searchValue,
    filterStatus,
    academicYear,
    workTypeCode,
    token
  ) => {
    this.setState({ loading: true });
    const result = await req_page_tqa_a00_worktype(
      userCode,
      userLevel,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      academicYear,
      workTypeCode,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
    this.setState({ loading: false });
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_tqa_a00(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    this.setState({ loading: true });
    const result = await req_edit_tqa_a00(item, token);
    this.setState({ loading: false });
    //console.log(result);
    if (result.status === "success") {
      message.success(result.message);
      this.api_page_items(this.current);
    } else {
      message.error(result.message);
    }
  };

  api_downloadfile = async (fileUrl) => {
    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "學年度",
        dataIndex: "AcademicYear",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "文件名稱",
        dataIndex: "RecordTitle",
        width: 50,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "版本",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { RecordVersion } = item;
          return (
            <div className="text-center">
              <Tag>{RecordVersion}</Tag>
            </div>
          );
        },
      },
      {
        title: "狀態",
        width: 20,
        responsive: ["md"],
        render: (item) => {
          const { RecordStatus } = item;
          return (
            <div className="text-center">
              <Tag color={this.style_switch_color_tag(RecordStatus)}>
                {this.style_switch_text_tag(RecordStatus)}
              </Tag>
            </div>
          );
        },
      },
      {
        title: "",
        dataIndex: "",
        width: 20,
        render: (item) => {
          const { RecordFileUrl, RecordStatus } = item;
          return (
            <>
              {" "}
              {RecordFileUrl === "NA" || RecordFileUrl === "" ? (
                ""
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.api_downloadfile(RecordFileUrl)}
                    disabled={RecordStatus !== "RELEASE"}
                  >
                    <i className="fas fa-cloud-download-alt"></i>
                    <span style={{ marginLeft: "4px" }}>下載</span>
                  </button>
                </>
              )}
            </>
          );
        },
      },
    ];
  };

  style_switch_text_tag(column) {
    let ans = "其他";
    switch (column) {
      case "EDIT":
        ans = "規劃中";
        break;
      case "CANCEL":
        ans = "已註銷";
        break;
      case "RELEASE":
        ans = "已發佈";
        break;
      default:
        // OTHER
        break;
    }
    return ans;
  }

  style_switch_color_tag(column) {
    let ans = "其他";
    switch (column) {
      case "RELEASE":
        ans = "#87d068";
        break;
      case "EDIT":
        ans = "#108ee9";
        break;
      case "CANCEL":
        ans = "grey";
        break;
      default:
        ans = "gold";
        break;
    }
    return ans;
  }

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    const { Uid } = item;
    const { userCode } = this.props.user;
    switch (modal) {
      case "ADD":
        this.setState({ isAddModal: true, item });
        break;
      case "EDIT":
        this.setState({ isEditModal: true, item });
        break;
      case "DELETE":
        Modal.confirm({
          title: `您確定刪除此筆檔案!`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "RELEASE":
        var row = {
          Uid: Uid,
          RecordEditor: userCode,
          condition: "RELEASE",
        };
        Modal.confirm({
          title: `發佈後將無法刪除，並公開給品管老師使用，是否確定發佈?`,
          onOk: () => {
            this.api_edit_item(row);
          },
        });
        break;
      case "CANCEL":
        row = {
          Uid: Uid,
          RecordEditor: userCode,
          condition: "CANCEL",
        };
        Modal.confirm({
          title: `註銷後將無法提供品管老師下載，是否確定註銷?`,
          onOk: () => {
            this.api_edit_item(row);
          },
        });
        break;
      default:
    }
  };

  handle_ui_field_change = (target_key, target_field, e) => {
    const value = e.target.value;
    const item = {
      activityNid: target_key,
      setPoints: value,
      condition: target_field,
    };
    //console.log(target_key)
    this.api_modify_item(item);
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      item,
      items,
      pagination,
      searchField,
      searchValue,
      academicYear,
      isEditModal,
      isAddModal,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={academicYear}
          onChange={(event) =>
            this.setState({ academicYear: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="RecordTitle">文件名稱</Select.Option>
          <Select.Option value="RecordVersion">版本</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Id"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <Modal
          destroyOnClose={true}
          visible={isEditModal}
          width={600}
          onOk={() => {
            this.setState({ isEditModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isEditModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <QuailtyManualLevelAModal manual={item} modalstate={"isEditModal"} />
        </Modal>
        <Modal
          destroyOnClose={true}
          visible={isAddModal}
          width={600}
          onOk={() => {
            this.setState({ isAddModal: false });
            this.handle_data_refresh();
          }}
          onCancel={() => {
            this.setState({ isAddModal: false });
          }}
          cancelButtonProps={{ style: { display: "none" } }}
        >
          <QuailtyManualLevelAModal modalstate={"isAddModal"} />
        </Modal>
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(DownloadTemplateModal);
